import {
  SET_BACK_PATHNAME,
  SET_CLOSE_PATHNAME,
  SET_IS_BACK_BUTTON_VISIBLE,
  SET_IS_CLOSE_BUTTON_VISIBLE,
} from './constants'
import { NavbarContextAction, NavbarContextState } from './types'

export const reducer = (
  state: NavbarContextState,
  action: NavbarContextAction
): NavbarContextState => {
  switch (action.type) {
    case SET_BACK_PATHNAME:
      return {
        ...state,
        backPathname: action.backPathname,
      }
    case SET_CLOSE_PATHNAME:
      return {
        ...state,
        closePathname: action.closePathname,
      }
    case SET_IS_BACK_BUTTON_VISIBLE:
      return {
        ...state,
        isBackButtonVisible: action.isBackButtonVisible,
      }
    case SET_IS_CLOSE_BUTTON_VISIBLE:
      return {
        ...state,
        isCloseButtonVisible: action.isCloseButtonVisible,
      }
    default:
      return state
  }
}
